export const USER_ID = document.querySelector('meta[name="user-id"]').content;
export const LOAD_ECHO = document.querySelector('meta[name="load-echo"]')?.content === "1";
export const GEO_REGION = document.querySelector('meta[name="geo-region"]').content;

export const CSRF_TOKEN = document.querySelector('meta[name="csrf-token"]').content;

export const AWS_LOCATION_KEY = import.meta.env.VITE_AWS_LOCATION_KEY;

export const CLOUDINARY_CLOUD = import.meta.env.VITE_CLOUDINARY_CLOUD;
export const CLOUDINARY_KEY = import.meta.env.VITE_CLOUDINARY_KEY;
export const CLOUDINARY_UPLOAD_PRESET = import.meta.env.VITE_CLOUDINARY_UPLOAD_PRESET;
export const FINGERPRINT_ENDPOINT = import.meta.env.VITE_FINGERPRINT_ENDPOINT;
export const FINGERPRINT_KEY = import.meta.env.VITE_FINGERPRINT_KEY;

export const MAPBOX_ACCESS_TOKEN = import.meta.env.VITE_MAPBOX_ACCESS_TOKEN;

export const PRELUDE_SDK_KEY = import.meta.env.VITE_PRELUDE_SDK_KEY;

export const REVERB_APP_KEY = import.meta.env.VITE_REVERB_APP_KEY;
export const REVERB_HOST = import.meta.env.VITE_REVERB_HOST;
export const REVERB_PORT = import.meta.env.VITE_REVERB_PORT;
export const REVERB_SCHEME = import.meta.env.VITE_REVERB_SCHEME;

export const STRIPE_KEY = import.meta.env.VITE_STRIPE_KEY;
